'use client';

import Image from '@/components/Image';
import { Link } from '@/i18n/navigation';
import { cn } from '@/utils/tailwind-merge';
import AnimatedArrow from './AnimatedArrow';

interface ArrowLinkProps extends React.HTMLAttributes<HTMLAnchorElement> {
    label: string;
    href: string;
    className?: string;
    target?: string;
}

const ArrowLink = (props: ArrowLinkProps) => {
    const { label, href, className, ...rest } = props;
    return (
        <Link
            href={href}
            {...rest}
            className={cn(
                'flex items-center gap-5 uppercase text-[32px] leading-8 font-normal font-trade-gothic text-white hover:text-primary transition-colors duration-300 group',
                className,
            )}
        >
            {label}
            <AnimatedArrow />
        </Link>
    );
};

export default ArrowLink;
